import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import LotsDataTable from "lib/components/builders/communities/lots/LotsDataTable";
import LotsView from "lib/components/builders/communities/lots/LotsView";
import { useUserContext } from "lib/state/UserContextProvider";
import withAuthentication from "../../../../../../components/withAuthentication";

function LotsPage() {
  const { enabledFeatures } = useUserContext();

  return (
    <CommunityLayout currentPage="lots">{enabledFeatures.lots2 ? <LotsDataTable /> : <LotsView />}</CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/lots/")({
  component: withAuthentication(LotsPage, { permissions: ["VIEW_LOTS"] }),
});
